import _extends from "@babel/runtime/helpers/extends";
/* eslint arrow-parens: 0 */
/**
 * Desc: The value component in the filter list item does not have a simple dependency.
 * It has dependency on both type and value and some metadata of type as well.
 * Wanted to keep `FilterListItem` generic hence did not hardcode the logic inside it.
 */

import React from 'react';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Factory
import getComponentForFilter from './withFilterValue.factory';

// Helpers
import { getFilterType, checkFieldExistenceSelected } from './withFilterValue.helpers';
import { getFilterId, getFilterName } from '../../helpers/filterDialog.filterType';
var withFilterValue = function withFilterValue(WrappedComponent) {
  return function (props) {
    var filterTypes = props.filterTypes,
      _props$value = props.value,
      value = _props$value === void 0 ? EMPTY_OBJECT : _props$value;
    var selectedFilterType = value.type;
    var filterType = getFilterType(selectedFilterType, filterTypes);
    var componentDetails = getComponentForFilter(filterType, value);
    var isCheckFieldExistenceSelected = checkFieldExistenceSelected(filterType, value);
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      valueComponent: componentDetails.component,
      baseProps: componentDetails.baseProps,
      types: filterTypes,
      getTypeLabel: getFilterName,
      getTypeValue: getFilterId,
      isCheckFieldExistenceSelected: isCheckFieldExistenceSelected
    }));
  };
};
export default withFilterValue;